/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type subsidy_SubsidyOfficeUpdateRequest = {
    address_line_1?: string;
    address_line_2?: string;
    calculation_method?: subsidy_SubsidyOfficeUpdateRequest.calculation_method;
    city?: string;
    country?: string;
    iban?: string;
    name?: string;
    notes?: string;
    postal_code?: string;
    qr_iban?: string;
};
export namespace subsidy_SubsidyOfficeUpdateRequest {
    export enum calculation_method {
        ZURICH_BF = 'zurich_bf',
        FLAT = 'flat',
    }
}

